import { Container, Segment, SegmentHeader } from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import QuestionnaireForm from '../Questionnaires/components/QuestionnaireForm';
import Navigation from './components/Navigation';

const QuestionnaireSettingsView = () => {
    const { auth } = usePage().props;

    return (
        <Container fluid>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='Vragenlijst instellingen'
                    subheader='Gebruik deze sectie om klant specifieke no-risk vragen te definiëren die in vragenlijsten zullen verschijnen.'
                />
            </Segment>

            <QuestionnaireForm
                submitUrl={`/customers/${auth?.user?.selected_customer_id}/services/no-risk/settings/questionnaires`}
            />
        </Container>
    );
};

export default QuestionnaireSettingsView;
